var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImg)?_c('img',{staticClass:"default",style:(_vm.imageStyle),attrs:{"alt":_vm.name,"src":_vm.src}}):_c('div',{staticClass:"default image-background",style:(_vm.backgroundStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }